import React from 'react'
import {
  Container,
  Divider,
  Grid,
  Typography,
  makeStyles
} from '@material-ui/core'
import AsterTabs from 'asterX-UIkit/Tabs/AsterTabs'
import AsterTab from 'asterX-UIkit/Tabs/AsterTab'
import { a11yProps } from 'asterX-UIkit/Tabs/TabPanel'
import UserPanel from './components/userPanel/UserPanel'
import CreationPanel from './components/creationPanel/CreationPanel'

import { LoaderBackdrop } from 'asterX-UIkit/Loaders'
import { useTranslation } from 'react-i18next'
import { useHomeStore } from 'context/HomeStore'

const useStyles = makeStyles(() => ({
  root: {
    marginTop: 40,
    marginBottom: 30,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: 8
  },
  title: {
    fontSize: 30,
    fontWeight: 600
  },
  subtitle: {
    fontSize: 16,
    fontWeight: 400
  }
}))

const Home = () => {
  const { t } = useTranslation()
  const {
    homeStore: { loading, selectedTab },
    homeStoreFunc: { onChangeTab }
  } = useHomeStore()
  const classes = useStyles()

  const configTabs = () => [
    { label: t('home.createRequest'), value: 0 },
    { label: t('home.myApplications'), value: 1 }
  ]

  const tabs = [<CreationPanel />, <UserPanel />]

  return (
    <Container className={classes.root} fullWidth>
      <LoaderBackdrop loading={loading} />
      <Grid
        container
        direction={'column'}
        xs={12}
        md={12}
        justifyContent={'flex-start'}
        style={{ marginBottom: 24 }}
      >
        <Typography className={classes.title}>Поддержка</Typography>
        <Typography className={classes.subtitle}>
          Обращайтесь сюда для оперативной поддержки и разрешения возникших
          трудностей.
        </Typography>
      </Grid>
      <Grid
        item
        container
        direction={'row'}
        justifyContent={'flex-start'}
        alignItems={'center'}
        spacing={2}
      >
        <Grid item xs={12} md={12}>
          <Grid item container justifyContent="space-between" xs={12} md={12}>
            <AsterTabs
              value={selectedTab}
              onChange={onChangeTab}
              variant="scrollable"
              scrollButtons="auto"
            >
              {configTabs().map((tab, idx) => (
                <AsterTab
                  label={tab.label}
                  {...a11yProps(tab.value)}
                  value={tab.value}
                  key={`tab_${idx}`}
                />
              ))}
            </AsterTabs>
          </Grid>
          <Divider />
          <div>{tabs[selectedTab]}</div>
        </Grid>
      </Grid>
    </Container>
  )
}

export default Home
